import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { EmpresaService } from 'src/app/components/empresa/empresa.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { RegionService } from 'src/app/utils/regiones/region.service';
import { RutValidator } from 'src/app/utils/rut.directive';
import { SentryService } from 'src/app/utils/sentry/sentry.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { ValidatorService } from 'src/app/utils/validators/validator.service';

@Component({
  selector: 'app-info-empresa-alert',
  templateUrl: './info-empresa-alert.component.html',
  styleUrls: ['./info-empresa-alert.component.scss']
})
export class InfoEmpresaAlertComponent implements OnInit {
  @Input() element: any = null;

  form: FormGroup = new FormGroup({});
  mask_empresa: string = '';
  maskDocumentoIdentidad = '';
  labelDocumentoIdentidad = '';

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private loading: LoadingService,
    private alerts: AlertService,
    public service: EmpresaService,
    private sentryService: SentryService,
    private validatorService: ValidatorService,
    public regionService: RegionService,
    public sesion: SesionService,
    public formatter: FormatterService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      rut: ['', [this.sesion.esPaisChile() ? RutValidator() : Validators.nullValidator]],
      email: ['', [Validators.required, Validators.email]],
      razon_social: ['', [Validators.required]],
      pais_id: [''],
    }, {
      validator: [
        this.validatorService.subRequired('rut', 'pais_id', [46])
      ]
    });
    this.labelDocumentoIdentidad = this.formatter.labelDocumentoIdentidadEmpresa();
    this.maskDocumentoIdentidad = this.formatter.maskDocumentoIdentidad();
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
      return;
    }
    this.loading.show();
    this.service.updateMiEmpresa(this.form.value).subscribe({
      next: (res) => {
        this.loading.hide();
        this.activeModal.close(res.model);
        this.sesion.actualizarPaisIdUser(this.form.value.pais_id);
        this.alerts.addAlert("Información de la empresa actualizada con éxito.", "success");
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.sentryService.captureException(err);
        this.alerts.addAlert("No se pudo actualizar la información de empresa.", "danger");
        if (err.error && err.error.response) this.alerts.addAlert(err.error.response, "danger");
      }
    });
  }
}
